import { createContext, FC, ReactNode, useContext } from 'react';
import { Company, MetaEntity } from '../../_BLL/types';

interface Context {
	currentCompany: Company;
	companyMeta: MetaEntity;
}

interface Props extends Context {
	children: ReactNode;
}

const CompanyFormContext = createContext<Context | null>(null);

const CompanyFormContextProvider: FC<Props> = (props) => {
	const {
		currentCompany, //
		companyMeta,
		children,
	} = props;

	// * Render
	return (
		<CompanyFormContext.Provider
			value={{
				currentCompany,
				companyMeta,
			}}
		>
			{children}
		</CompanyFormContext.Provider>
	);
};

const useCompanyFormContext = () => {
	const context = useContext(CompanyFormContext);

	if (!context) {
		throw new Error('useCompanyFormContext must be used within CompanyFormContext');
	}

	return context;
};

export { CompanyFormContextProvider, useCompanyFormContext };
